// src/utils/coreassure/readinessApi.js
//
// CoreAssure ReadyCore (D-048 §4.1) — Day 2-3 MVP frontend API client.
// Mirrors the convention of calibrationApi.js, detailerQualificationsApi.js, etc.
// Per CR-2026-CA-NAMESPACE §2.1: file lives under src/utils/coreassure/.
// Per CR-2026-CA-READYCORE-RENAME §3.2: code identifier is `readiness`
// (function-descriptive), NOT `readyCore` (brand-named).

import ApiCall from "../apicall";

// ── Readiness score (read-only, on-demand) ──────────────────────────────────
export const readinessApi = {
  /**
   * Compute readiness score for a job.
   * @param {number|string} jobId
   * @returns axios response. data.data is the score envelope per
   *   CR-2026-CA-READYCORE-MVP §4 API contract.
   */
  scoreForJob: (jobId) => ApiCall.get(`/coreassure/readiness?jobId=${encodeURIComponent(jobId)}`),
};

// ── Color thresholds (kept in sync with backend) ────────────────────────────
export const READINESS_COLOR = {
  GREEN: "GREEN",
  AMBER: "AMBER",
  RED: "RED",
};

export const READINESS_COLOR_PALETTE = {
  GREEN: { bg: "#e8f5ec", fg: "#127038", border: "#127038" },
  AMBER: { bg: "#fff5e0", fg: "#a06010", border: "#a06010" },
  RED:   { bg: "#fdecea", fg: "#a01a1a", border: "#a01a1a" },
};

export const CATEGORY_LABEL = {
  drawings:    "Drawings (revision status)",
  materials:   "Materials (heat status)",
  personnel:   "Personnel (welder qualification)",
  calibration: "Calibration (in-cal status)",
  tooling:     "Tooling (in service)",
  procedures:  "Procedures (drawing ack)",
};

export function colorForScore(score) {
  if (score >= 90) return READINESS_COLOR.GREEN;
  if (score >= 60) return READINESS_COLOR.AMBER;
  return READINESS_COLOR.RED;
}
